var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.017 8H3.983C1.783 8 0 9.783 0 11.983v24.034C0 38.217 1.783 40 3.983 40h24.034c2.2 0 3.983-1.783 3.983-3.983V11.983C32 9.783 30.217 8 28.017 8zM43.8 11.142l-9.133 6.3v13.116L43.8 36.85c1.767 1.217 4.2-.025 4.2-2.15V13.292c0-2.117-2.425-3.367-4.2-2.15z"
  })));
};
export default SvgVideo;